import { useBackend } from "../../services";
import { useGetPaginatedAttributes } from "../attributes/useGetPaginatedAttributes";
import { IAlbumType } from "./interfaces";
import {
  IGetPaginatedAttributeProps,
  IPublicGetPaginatedAttributeProps
} from "../attributes/interfaces";
import { useCollectionManager } from "../collections/useCollectionManager";
import { PageSizeHelper } from "../../models/PageSizeHelper";
import { useUser } from "../session";
import { UserRole } from "../users";
import { DataStorage } from "../../models/DataStorage";

export const useGetAlbumTypes = (isPublic: boolean, setLoading: (loading: boolean) => void) => {
  const { get } = useBackend();
  const { getCurrentCollection } = useCollectionManager();
  const [currentUser] = useUser.useState();
  const getAlbumTypes = (parameters: IGetPaginatedAttributeProps) => get("albumTypes", parameters);
  const getPublicAlbumTypes = (parameters: IPublicGetPaginatedAttributeProps) =>
    get("albumTypes/shared/public", parameters);
  return useGetPaginatedAttributes<IAlbumType>(
    PageSizeHelper.albumTypes(currentUser?.role ?? UserRole.common),
    isPublic ? getPublicAlbumTypes : getAlbumTypes,
    setLoading,
    DataStorage.albumTypeStorage,
    isPublic,
    true,
    getCurrentCollection(isPublic)?.uuid
  );
};
